import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/es';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, DEFAULT_NAMESPACE, LANGUAGE_CODES, NAMESPACES } from './constants';
import { resources } from './resources';

moment.locale(DEFAULT_LOCALE);

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        load: 'languageOnly',
        supportedLngs: Object.values(LANGUAGE_CODES),
        fallbackLng: DEFAULT_LOCALE, // en

        ns: Object.values(NAMESPACES),
        defaultNS: DEFAULT_NAMESPACE,

        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false,
            format: (value, format, lng) => {
                const m = moment(value);
                if (!m.isValid()) return value;
                m.locale(lng);
                switch (format) {
                    case 'date_short':
                        return m.format('ll');
                    case 'date_long':
                        return m.format('LL');
                    case 'time_only':
                        return m.format('LT');
                    case 'date_time_seconds':
                        return m.format('l HH:mm:ss');
                    case 'date_time_seconds_display':
                        return m.format('l LTS');
                    case 'date_time_short':
                        return m.format('ll LT');
                    case 'month_day':
                        return m.format('MMM DD');
                    default:
                        return value;
                }
            },
        },
        detection: {
            order: ['path', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            caches: ['localStorage'],
        },
    });

export default i18n;
